﻿// lowercase fist letter
$('.first-letter-low').each(function(){
    var $this = $(this);
    var text = $this.text();

    $this.text(text.charAt(0).toLowerCase() + text.slice(1))
});